export default "__VITE_ASSET__6f3b698d__"